import React from 'react';

// Minimal base; textareas are themed globally via index.css (textarea selector)
const baseClasses = 'brand-textarea';

export const Textarea = React.forwardRef(function Textarea({ className = '', ...props }, ref) {
  const classes = [baseClasses, className].filter(Boolean).join(' ');
  return <textarea ref={ref} className={classes} {...props} />;
});

Textarea.displayName = 'Textarea';

export default Textarea;
